module.exports = __webpack_public_path__ + "static/media/minsk-gov.636ea596.png";